import { IdType, IdValuePairsType } from 'types/WidgetTypes';

/*
 * widgetDataUtils.ts
 * Shared helper for widgets which read the generic ids or
 * id-value-pairs widget data shape, used by both NumberWidget and
 * RatioWidget so a ratio can be based on a count of ids as well as
 * a sum of values, such as hours.
 */

// Sums a widget data array: counts the entries for a plain list of ids,
// or sums each entry's value field, converted to a number, for id-value pairs
export const sumWidgetValues = (data: IdType | IdValuePairsType): number => {
    if (!data.length) {
        return 0;
    }

    if (typeof data[0] === 'number') {
        return data.length;
    }

    return (data as IdValuePairsType).reduce((sum, entry) => sum + (parseFloat(entry.value) || 0), 0);
};
